import { ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges } from '@angular/core';
import { ContentLanguageLabelModel } from '@fi-shared/models';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';

@Component({
    selector: 'fi-content-language-label',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ContentLanguageLabelComponent implements OnChanges {
    constructor(
        private elementRef: ElementRef,
        private userDataService: FiUserDataService,
    ) {}

    @Input() labels: Array<ContentLanguageLabelModel>;

    ngOnChanges(changes) {
        if (changes.labels) this.updateLabelValue();
    }

    updateLabelValue() {
        this.elementRef.nativeElement.textContent = this.getLabelValue();
    }

    getLabelValue() {
        let i;
        for (i = 0; i < this.labels.length; i++) {
            const li = this.labels[i];
            if (li.ContentLanguageId === this.userDataService.applicationLanguage) return li.Value;
        }
    }
}
